import * as React from "react";
const SvgOk = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 30 22" {...props}><path d="M30 2.29 10.3 22l-.29-.29-.3.29-9.7-9.71L2.3 10l7.71 7.72L27.71 0Z" /></svg>;
export default SvgOk;